






































import mixins from 'vue-typed-mixins';
import DocumentsUtils, { Document } from '@/utils/DocumentsUtils';
import cloneDeep from 'lodash.clonedeep';
import { SurveyParticipation } from '@/utils/SurveyUtils';
import questions from '../survey/questions';

export default mixins().extend({
  props: {
    template: {
      type: Object as () => Partial<Document>,
    },
    disabled: {
      type: Boolean as () => boolean,
    },
    surveyparticipation: {
      type: Object as () => SurveyParticipation,
    },
  },

  computed: {
    default(): Partial<Document> {
      return {
        description: undefined,
        serviceprovider: undefined,
        surveyparticipation: this.surveyparticipation,
        associations: [],
        ...this.template,
      };
    },
  },

  data(): {
    visible: boolean;
    inprogress: any;
    document: Partial<Document>;
    file?: any;
  } {
    return {
      visible: false,
      inprogress: undefined, // when not null upload is in progress
      document: {},
      file: undefined,
    };
  },

  mounted() {
    this.document = cloneDeep(this.default);
  },

  watch: {
    visible() {
      this.file = undefined;
      this.document = cloneDeep(this.default);
    },
  },

  methods: {
    async upload() {
      this.inprogress = true;

      try {
        this.$alert.hide('upload');
        this.$emit(
          'upload',
          await DocumentsUtils.api.add(this.document, this.file)
        );
        this.visible = false;
      } catch (error) {
        this.$alert.show('upload', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }

      this.inprogress = false;
    },
  },
});
